import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react"
import Vimeo from "@u-wave/react-vimeo"
import styles from "../endlesss.module.scss"

import Quote from "./quote"

import ProgressBar from "./progressBar"
import "./useFade.css"

import speaker from "../../../../images/athena-04-resilience/endlesss/speaker.png"

const SonicVimeo = forwardRef((props, sonicVideo) => {
  useImperativeHandle(sonicVideo, () => ({
    startPlaying() {
      setPlaying(true)
    },
    pauseVid() {
      setPlaying(false)
    },
    resumeVid() {
      setPlaying(true)
    },
    stopPlaying() {
      setPlaying(false)
    },
  }))

  const {
    toggleInfo,
    modalOpen,
    sendDataToParent,
    isActive,
    transitionEnded,
  } = props
  const player = useRef(null)

  const [playing, setPlaying] = useState(false)
  const [played, setPlayed] = useState(0)
  const [prog, setProgress] = useState(0)

  const [showOne, setShowOne] = useState(false)
  const [showTwo, setShowTwo] = useState(false)
  const [showThree, setShowThree] = useState(false)
  const [showFour, setShowFour] = useState(false)
  const [showFive, setShowFive] = useState(false)
  const [showSix, setShowSix] = useState(false)
  const [showSeven, setShowSeven] = useState(false)
  const [showEight, setShowEight] = useState(false)
  const [showNine, setShowNine] = useState(false)
  const [showTen, setShowTen] = useState(false)
  const [showEleven, setShowEleven] = useState(false)
  const [showTwelve, setShowTwelve] = useState(false)
  const [showThirteen, setShowThirteen] = useState(false)
  const [showFourteen, setShowFourteen] = useState(false)
  const [showFifteen, setShowFifteen] = useState(false)
  const [showSixteen, setShowSixteen] = useState(false)
  const [showSeventeen, setShowSeventeen] = useState(false)
  const [showEighteen, setShowEighteen] = useState(false)
  const [showNineteen, setShowNineteen] = useState(false)
  const [showTwenty, setShowTwenty] = useState(false)
  const [showTwentyOne, setShowTwentyOne] = useState(false)
  const [showTwentyTwo, setShowTwentyTwo] = useState(false)
  const [showTwentyThree, setShowTwentyThree] = useState(false)

  const [speakerFade, setSpeakerFade] = useState(true)
  useEffect(() => {
    const timeId = setTimeout(() => {
      setSpeakerFade(false)
    }, 10000)
    return () => {
      clearTimeout(timeId)
    }
  }, [])

  const [unmountSpeaker, setUnmountSpeaker] = useState(true)
  useEffect(() => {
    const timer = setTimeout(() => {
      setUnmountSpeaker(false)
    }, 20000)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  const [chatIsActive, setChatActive] = useState(false)
  const activateChat = () => {
    setChatActive(!chatIsActive)
    sendDataToParent(chatIsActive)
  }

  const [slideChanged, setSlideChanged] = useState(false)
  useEffect(() => {
    const timeId = setTimeout(() => {
      setSlideChanged(true)
    }, 1000)
    return () => {
      clearTimeout(timeId)
    }
  }, [])

  const [chatFade, setChatFade] = useState(false)
  useEffect(() => {
    const timeId = setTimeout(() => {
      setChatFade(true)
    }, 2000)
    return () => {
      clearTimeout(timeId)
    }
  }, [])

  let fromProps = {
    style: { animation: `fadeIn 0.7s` },
  }
  const bottomRef = useRef(null)
  const mobilBottomRef = useRef(null)

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    bottomRef.current?.scrollIntoView({ behavior: "smooth" })
    // eslint-disable-next-line no-unused-expressions
    mobilBottomRef.current?.scrollIntoView({ behavior: "smooth" })
  }, [
    showOne,
    showTwo,
    showThree,
    showFour,
    showFive,
    showSix,
    showSeven,
    showEight,
    showNine,
    showTen,
    showEleven,
    showTwelve,
    showThirteen,
    showFourteen,
    showFifteen,
    showSixteen,
    showSeventeen,
    showEighteen,
    showNineteen,
    showTwenty,
    showTwentyOne,
    showTwentyTwo,
    showTwentyThree,
  ])

  return (
    <>
      <Vimeo
        ref={player}
        className={styles.vimeoVideo}
        // video={'https://vimeo.com/834431673/ffdc9d8bb5'}
        video={"https://vimeo.com/837966957/e18a81e04a"}
        controls={false}
        autoPlay={false}
        loop={true}
        playsInline={true}
        paused={playing ? false : true}
        playing={playing ? true : false}
        muted={false}
        autopause={true}
        onPlaying={() => {
          setPlaying(true)
        }}
        onTimeUpdate={progress => {
          setPlayed(progress.seconds)
          setProgress(progress.percent)
          const currentTime = progress.seconds
          // console.log(progress, currentTime)
          if (currentTime >= "00") {
            setShowOne(true)
          }
          if (currentTime >= "04") {
            setShowTwo(true)
          }
          if (currentTime >= "08") {
            setShowThree(true)
          }
          if (currentTime >= "16") {
            setShowFour(true)
          }
          if (currentTime >= "23") {
            setShowFive(true)
          }
          if (currentTime >= "26") {
            setShowSix(true)
          }
          if (currentTime >= "30") {
            setShowSeven(true)
          }
          if (currentTime >= "32") {
            setShowEight(true)
          }
          if (currentTime >= "38") {
            setShowNine(true)
          }
          if (currentTime >= "48") {
            setShowTen(true)
          }
          if (currentTime >= "59") {
            setShowEleven(true)
          }
          if (currentTime >= "63") {
            setShowTwelve(true)
          }
          if (currentTime >= "72") {
            setShowThirteen(true)
          }
          if (currentTime >= "93") {
            setShowFourteen(true)
          }
          if (currentTime >= "111") {
            setShowFifteen(true)
          }
          if (currentTime >= "127") {
            setShowSixteen(true)
          }
          if (currentTime >= "143") {
            setShowSeventeen(true)
          }
          if (currentTime >= "162") {
            setShowEighteen(true)
          }
          if (currentTime >= "191") {
            setShowNineteen(true)
          }
          if (currentTime >= "206") {
            setShowTwenty(true)
          }
          if (currentTime >= "210") {
            setShowTwentyOne(true)
          }
          if (currentTime >= "222") {
            setShowTwentyTwo(true)
          }
          if (currentTime >= "226") {
            setShowTwentyThree(true)
          }
        }}
      />
      <ProgressBar playing={playing} completed={prog * 100} />

      {isActive && slideChanged && transitionEnded && (
        <div
          style={{ opacity: chatFade ? "1" : "0", transition: "0.3s" }}
          className={styles.chatContainer}
        >
          <div className={`${styles.chatsMobile}`}>
            {!toggleInfo && modalOpen && !chatIsActive && (
              <div
                className={styles.soundOn}
                style={{
                  position: "absolute",
                  bottom: "0",
                  left: "0",
                  right: "0",
                  margin: "auto",
                  transition: "all .6s ease-in-out",
                  opacity: speakerFade ? 1 : 0,
                }}
              >
                <img src={speaker} alt="speaker" />
                <p>sound on for Best Experience</p>
              </div>
            )}
            <button
              onClick={activateChat}
              className={`${styles.chatButton} ${
                chatIsActive ? styles.active : ""
              }`}
            >
              <Quote className={chatIsActive ? styles.active : ""} />
            </button>
            <div
              style={{
                height: "100%",
                opacity: chatIsActive ? "1" : "0",
              }}
              className={styles.chatBlurContainer}
            >
              <div className={styles.chatContainerInner}>
                <>
                  {showOne && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Synth By Firephly</h5>
                      <h6>0:00</h6>
                    </div>
                  )}
                  {showTwo && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Arpeggiator By oddSTAR</h5>
                      <h6>0:04</h6>
                    </div>
                  )}
                  {showThree && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Bells By caerickson</h5>
                      <h6>0:08</h6>
                    </div>
                  )}
                  {showFour && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Keys By oddSTAR</h5>
                      <h6>0:16</h6>
                    </div>
                  )}
                  {showFive && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Saxophone By badrico</h5>
                      <h6>0:23</h6>
                    </div>
                  )}
                  {showSix && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Lazerbeak</h5>
                      <h6>0:26</h6>
                      <p>
                        I wanted this intro to start with a bunch of different
                        musical stems to set the tone, but then completely strip
                        away for the first vocals. It felt like a really
                        powerful way to grab the listener's attention and let
                        them know that things are gonna get EPIC.
                      </p>
                    </div>
                  )}
                  {showSeven && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>FeloniousMonk</h5>
                      <h6>0:30</h6>
                      <p>So much movement. That's awesome.</p>
                    </div>
                  )}
                  {showEight && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Vocals By Firephly</h5>
                      <h6>0:32</h6>
                    </div>
                  )}
                  {showNine && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Synth By thevoidinclusive</h5>
                      <h6>0:30</h6>
                    </div>
                  )}
                  {showTen && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Synth By oddSTAR</h5>
                      <h6>0:48</h6>
                    </div>
                  )}
                  {showEleven && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Vocals By thevoidinclusive</h5>
                      <h6>0:59</h6>
                    </div>
                  )}
                  {showTwelve && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Beat By oddSTAR</h5>
                      <h6>1:03</h6>
                    </div>
                  )}
                  {showThirteen && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Bells By badrico</h5>
                      <h6>1:12</h6>
                    </div>
                  )}
                  {showFourteen && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Guitar By FeloniousMonk</h5>
                      <h6>1:36</h6>
                    </div>
                  )}
                  {showFifteen && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Lazerbeak</h5>
                      <h6>1:51</h6>
                      <p>
                        Once we got through the first big moment of the song, I
                        wanted to strip back all the way to just this really
                        meditative guitar. From there we could slowly build
                        stems layer by layer as we march to the finish.
                      </p>
                    </div>
                  )}
                  {showSixteen && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Vocals By Firephly</h5>
                      <h6>2:07</h6>
                    </div>
                  )}
                  {showSeventeen && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Vocals By Njlang</h5>
                      <h6>2:32</h6>
                    </div>
                  )}
                  {showEighteen && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Lazerbeak</h5>
                      <h6>2:42</h6>
                      <p>
                        I pictured this section as the calm before the storm.
                        Something really pretty and retrospective before
                        everything comes in for the big finale. A chance to
                        catch your breath before everything goes bonkers.
                      </p>
                    </div>
                  )}
                  {showNineteen && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Guitar By oddSTAR</h5>
                      <h6>3:11</h6>
                    </div>
                  )}
                  {showTwenty && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>TheVoidInclusive</h5>
                      <h6>3:26</h6>
                      <p>Man the guitars are epic</p>
                    </div>
                  )}

                  {showTwentyOne && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>TheVoidInclusive</h5>
                      <h6>3:30</h6>
                      <p>
                        And that high synth! <span>✨💖✨</span>
                      </p>
                    </div>
                  )}

                  {showTwentyTwo && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Percussion By Firephly</h5>
                      <h6>3:42</h6>
                    </div>
                  )}
                  {showTwentyThree && (
                    <div {...fromProps} className={styles.chatBox}>
                      <h5>Percussion By oddSTAR</h5>
                      <h6>3:46</h6>
                    </div>
                  )}

                  <div ref={mobilBottomRef} />
                </>
              </div>
            </div>
          </div>
          <div className={`${styles.chatsDesktop}`}>
            <div className={styles.chatBlurContainer}>
              <div className={styles.chatContainerInner}>
                {!toggleInfo && modalOpen && (
                  <>
                    {unmountSpeaker && (
                      <div
                        className={styles.chatBox}
                        style={{
                          opacity: speakerFade ? 1 : 0,
                          justifyContent: "center",
                          // height: speakerFade ? 'auto' : '0px',
                          transition: "opacity .6s ease-in-out",
                        }}
                      >
                        <img src={speaker} alt="speaker" />
                        <h5>sound on for Best Experience</h5>
                      </div>
                    )}
                  </>
                )}

                {showOne && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Synth By Firephly</h5>
                    <h6>0:00</h6>
                  </div>
                )}
                {showTwo && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Arpeggiator By oddSTAR</h5>
                    <h6>0:04</h6>
                  </div>
                )}
                {showThree && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Bells By caerickson</h5>
                    <h6>0:08</h6>
                  </div>
                )}
                {showFour && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Keys By oddSTAR</h5>
                    <h6>0:16</h6>
                  </div>
                )}
                {showFive && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Saxophone By badrico</h5>
                    <h6>0:23</h6>
                  </div>
                )}
                {showSix && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Lazerbeak</h5>
                    <h6>0:26</h6>
                    <p>
                      I wanted this intro to start with a bunch of different
                      musical stems to set the tone, but then completely strip
                      away for the first vocals. It felt like a really powerful
                      way to grab the listener's attention and let them know
                      that things are gonna get EPIC.
                    </p>
                  </div>
                )}
                {showSeven && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>FeloniousMonk</h5>
                    <h6>0:30</h6>
                    <p>So much movement. That's awesome.</p>
                  </div>
                )}
                {showEight && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Vocals By Firephly</h5>
                    <h6>0:32</h6>
                  </div>
                )}
                {showNine && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Synth By thevoidinclusive</h5>
                    <h6>0:30</h6>
                  </div>
                )}
                {showTen && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Synth By oddSTAR</h5>
                    <h6>0:48</h6>
                  </div>
                )}
                {showEleven && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Vocals By thevoidinclusive</h5>
                    <h6>0:59</h6>
                  </div>
                )}
                {showTwelve && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Beat By oddSTAR</h5>
                    <h6>1:03</h6>
                  </div>
                )}
                {showThirteen && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Bells By badrico</h5>
                    <h6>1:12</h6>
                  </div>
                )}
                {showFourteen && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Guitar By FeloniousMonk</h5>
                    <h6>1:36</h6>
                  </div>
                )}
                {showFifteen && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Lazerbeak</h5>
                    <h6>1:51</h6>
                    <p>
                      Once we got through the first big moment of the song, I
                      wanted to strip back all the way to just this really
                      meditative guitar. From there we could slowly build stems
                      layer by layer as we march to the finish.
                    </p>
                  </div>
                )}
                {showSixteen && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Vocals By Firephly</h5>
                    <h6>2:07</h6>
                  </div>
                )}
                {showSeventeen && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Vocals By Njlang</h5>
                    <h6>2:32</h6>
                  </div>
                )}
                {showEighteen && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Lazerbeak</h5>
                    <h6>2:42</h6>
                    <p>
                      I pictured this section as the calm before the storm.
                      Something really pretty and retrospective before
                      everything comes in for the big finale. A chance to catch
                      your breath before everything goes bonkers.
                    </p>
                  </div>
                )}
                {showNineteen && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Guitar By oddSTAR</h5>
                    <h6>3:11</h6>
                  </div>
                )}
                {showTwenty && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>TheVoidInclusive</h5>
                    <h6>3:26</h6>
                    <p>Man the guitars are epic</p>
                  </div>
                )}

                {showTwentyOne && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>TheVoidInclusive</h5>
                    <h6>3:30</h6>
                    <p>
                      And that high synth! <span>✨💖✨</span>
                    </p>
                  </div>
                )}

                {showTwentyTwo && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Percussion By Firephly</h5>
                    <h6>3:42</h6>
                  </div>
                )}
                {showTwentyThree && (
                  <div {...fromProps} className={styles.chatBox}>
                    <h5>Percussion By oddSTAR</h5>
                    <h6>3:46</h6>
                  </div>
                )}
                <div ref={bottomRef} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
})
export default SonicVimeo
